import { Monitor, Terminal } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { Button } from '@/components/ui/button';

export function ThemeSwitcher() {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      onClick={toggleTheme}
      variant="outline"
      size="icon"
      className="fixed top-3 right-3 z-50 border-primary/30 bg-card/80 backdrop-blur-sm hover:bg-primary/10"
      aria-label={theme === 'cyber' ? 'Zum Terminal-Theme wechseln' : 'Zum Cyber-Theme wechseln'}
      title={theme === 'cyber' ? 'Terminal-Theme' : 'Cyber-Theme'}
    >
      {theme === 'cyber' ? (
        <Terminal className="w-4 h-4 text-primary" />
      ) : (
        <Monitor className="w-4 h-4 text-primary" />
      )}
    </Button>
  );
}
